import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import bcrypt from 'bcryptjs-react';
import { getImageUrl } from "../../common/utils";
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import IconButton from '@mui/material/IconButton';

const EmbedSlider = ({ url, baseDomain, constants,title,titleseo }) => {
  const [Imageitems, setImageItems] = useState([]);
  const formattedTitle = title?.length > 30 ? `${title.slice(0, 30)}...` : title
  useEffect(() => {
    const fetchSlideShow = async () => {
      try {
        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        const response = await fetch(url, { headers: headers });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const data = await response.json();
        setImageItems(data); // Store the fetched items
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    };

    fetchSlideShow();
  }, [url]);
  

  // Next Arrow component
  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="CustomNextArrow" onClick={onClick}>
        <IconButton>
          <ArrowForwardIosOutlinedIcon />
        </IconButton>
      </div>
    );
  };
   // Previous Arrow component
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="CustomPrevArrow" onClick={onClick}>
        <IconButton>
          <ArrowBackIosNewOutlinedIcon />
        </IconButton>
      </div>
    );
  };

  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    className: 'CommonEmbedSlider',
    slidesToShow: 4,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    swipeToSlide: true,
    variableWidth: true,
    arrows: true, // Keep arrows defined once
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        arrows: false,

      }
    }
  ]
};

  // Ensure the items are loaded before rendering
  if (!Imageitems?.items || Imageitems?.items.length === 0) {
    return <div></div>; // Optional loading state
  }
  
  return (
    <div className="CommonEmbedSlideShowMainWrapper">
    <a href={`/${titleseo}/photoshow/${Imageitems?.parentItems?.id}.html`} className="CommonEmbedSlideShowTitle">{formattedTitle}</a>
    <Slider {...settings}>
      {Imageitems && Imageitems?.items.map(item => (
        <div key={item.id}>
        <div className="CommonEmbedSlideeShowImageWrap">
            {/* <img src={`${getImageUrl(item.id, item.id, 212, undefined, baseDomain, false, constants)}`} alt={item.hl} /> */}
            <img src={`${getImageUrl(item.id, item.id, 240, undefined, baseDomain, false, constants)}`} alt={item.hl}
            style={{ maxWidth: '100%', height: 'auto' }} // Add responsive styling to images
          />
          </div>
          <h2>{item.hl}</h2>
          {/* <p className="CommonEmbedDiscription">{item.syn}</p> */}
        </div>
      ))}
    </Slider>
    </div>
  );
};

export default EmbedSlider;
